import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import Linkify from 'linkify-react';
import { withRouter } from "../withRouter"; 	// HOC pour React Router v6
import { ConnectedUserContext } from '../connectedUser-context';

import TeamStanding from './TeamStanding';
import PlayerStanding from './PlayerStanding';
import MatchsPlayed from './MatchsPlayed';
import Users from '../users/Users';

import * as myConstClass from '../shared/constants/constants';

const linkifyOptions = {
  defaultProtocol: 'https',
  target: '_blank',
  rel: 'noopener noreferrer',
  className: 'custom-link',
  attributes: { style: { color: '#a04020', fontWeight: 'normal' } },
};


class Standings extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			standingOption: 'teams',
			seasonObj: {},
			season: {},
			bTournamentType: false,
			custData: {},
			printLeagueMsg: false,
			bRateSysExists: false,
			loading: true,
		};
	
		this.teamRostersClick = this.teamRostersClick.bind(this);
		this.liveScoresheetsClick = this.liveScoresheetsClick.bind(this);
		this.rateSysFormClick = this.rateSysFormClick.bind(this);
		this.teamsButtonClicked = this.teamsButtonClicked.bind(this);
		this.playersButtonClicked = this.playersButtonClicked.bind(this);
		this.matchsPlayedButtonClicked = this.matchsPlayedButtonClicked.bind(this);

		this.seasonMsgButton1Click = this.seasonMsgButton1Click.bind(this);
		this.seasonMsgButton2Click = this.seasonMsgButton2Click.bind(this);
		this.pubEventsPubClicked = this.pubEventsPubClicked.bind(this);
		this.togglePrintLeagueMsg = this.togglePrintLeagueMsg.bind(this);
	}

	componentDidMount() {
		this.loadSeasonFromApi();
	}

	loadSeasonFromApi() {
		// console.log('loadSeasonFromApi');
		// console.log(this.props.match.params)
    var seasonTag = this.props.params.seasonTag;
    Axios.get('/api/seasons/tag/' + seasonTag).then(responseSeason => {

    	var seasonObj = responseSeason.data;
	    var seasonId = seasonObj.season._id;
    	if (seasonId === "0") {
    		const path = '/stats';
				this.props.navigate(path);

    	} else {
				Axios.get('/api/ratesys/rateSysExisting/' + seasonId).then(responseRatesys => {
					var bTournamentType = false;
					if(seasonObj.season.resultsType === myConstClass.RESTYPE_TOURNAMENT) {
						bTournamentType = true;
					}

					// need TEAMS format to display buttons for standingOption (standingOption default to team)
					var standingOption = "players";
					if (seasonObj.season.formatTeamIndiv === "TEAMS") {
						standingOption = "teams";
					}

					let page = standingOption.charAt(0).toUpperCase() + standingOption.slice(1).toLowerCase();

					this.setNewCustomerPub('loading', page, seasonId);
					this.setState({
						standingOption: standingOption,
						seasonObj: seasonObj,
						season: seasonObj.season,
						bTournamentType: bTournamentType,
						bRateSysExists: responseRatesys.data.exists,
						loading: false
					});
				});
    	}
		});
	}

	setNewCustomerPub(typeA, typeB, seasonId) {
		// -------------------------------------------
		// Customer image display
		var custPubA = myConstClass.CUSTPUB_A;
		var custIdx = 0;
		var cumulRatio = 0;

		var dispDraw = Math.random() * 100;
		// console.log(Math.round(dispDraw * 100) / 100);

		for (custIdx = 0; custIdx < custPubA.length; custIdx++) {
			cumulRatio += custPubA[custIdx].dispRatioPct;
			if (dispDraw <= cumulRatio) {
				break;
			}
		}
		var custData = custPubA[custIdx];
		this.pubEventsPubShowed(custData, typeA, typeB, seasonId);		// log customer display

		this.setState({
			custData: custData,
		});
	}

 	render() {
		// console.log('Standings: render');
		// console.log(this.props, this.state)
		if (this.state.loading) {
			return (
				<div className="animated fadeIn">
					<p></p>
				</div>
			)
		}

    const { connectedUser } = this.context;
    const isMasterAdmin = connectedUser ? connectedUser.isMasterAdmin : false;
    console.log("connectedUser", connectedUser);


		var dateUpdated = '';
		if (this.state.season.dateUpdated) {
			dateUpdated = moment(this.state.season.dateUpdated).utc().local().format("YYYY-MM-DD, HH:mm");
		}

		var leagueText = "Ligue: ";
		var msgText = "Message de la ligue";
		if (this.state.bTournamentType) {
			leagueText = "Tournoi: ";
			msgText = "Message du tournoi";
		}

		var teamsStandingsBtnClass = 'btn-primary';
		var playersStandingsBtnClass = 'btn-primary';
		var matchsPlayedBtnClass = 'btn-primary';

		if (this.state.standingOption === "teams") {
			playersStandingsBtnClass = 'btn-secondary';
			matchsPlayedBtnClass = 'btn-secondary';
		} else if (this.state.standingOption === "players") {
			teamsStandingsBtnClass = 'btn-secondary';			
			matchsPlayedBtnClass = 'btn-secondary';			
		} else {
			playersStandingsBtnClass = 'btn-secondary';			
			teamsStandingsBtnClass = 'btn-secondary';			
		}

		var printLeagueMsgClassName = 'no-print';		// default
		if (this.state.printLeagueMsg) {
			printLeagueMsgClassName = ''
		}

		var btnTxt1 = "Composition des Équipes";
		if (this.state.season.formatTeamIndiv !== "TEAMS") {
			btnTxt1 = "Liste des Inscriptions";
		}

		// NOMPBTN used in QVNEA-INDIV-10B leagues
		var noMatchPlayedBtn = (this.state.season.stateloLeagueParam.includes('NOMPBTN'));
		var bLiveScoresheets = (this.state.season.liveScoresheets.status === "ACTIVÉES");

		return (
			<div className="animated fadeIn row-margin-bottom-100">

				<div className="row">
				<div className="col-md-12">
					<h4>{this.state.season.name}</h4>
					<p>Mise-à-jour des statistiques: {dateUpdated}</p>
				</div>
				</div>

				<div className={"row " + printLeagueMsgClassName}>
				<div className="col-md-8">

					{/* Message de Ligue */}
					<div className="card card-accent-success">
						<div className="card-header"> <h5> {msgText} </h5> </div>
						<div className="card-block ligueMsg">
							{this.splitTextLinesWithCR(this.state.season.seasonMessage, true) || ""} <br/>

							<div className="row">
							<div className="col-md-12">
							{this.dispSeasonMsgButton1()}
							{this.dispSeasonMsgButton2()}
			 				</div>
			 				</div>

							{this.splitTextLinesWithCR(this.state.season.seasonMessage2, false) || ""}
	 					</div>
	 				</div>

					<div className="row no-print">
					<div className="col-12">
						<button className="btn btn-primary teamRostersBtn" onClick={this.teamRostersClick}>
							{btnTxt1}
						</button>

					{(bLiveScoresheets && isMasterAdmin) ? 
						<button className="btn btn-primary teamRostersBtn" onClick={this.liveScoresheetsClick}>
							Feuilles de pointage
						</button>
					: null}

						{(this.state.bRateSysExists) ? 
							<button className="btn btn-primary teamRostersBtn" onClick={this.rateSysFormClick}>
								Formulaire de Cotation
							</button>
						: null}

					</div>
					</div>


        	{/* Bannière publicité à déterminer */}
					{/*<a href="http://qvnea.com/fqsb/" target="_blank">*/}
					<div className="no-print">
					<a href="/tableau-de-bord">
	          <img className="img-fluid" src="/img/regulier-aut-2019-banner.png" alt="tableaudebord" width="1000"/>
					</a>
        	<br/>
	       	<hr/>
 	 				</div>

					{/* Boutons Équipes / Joueurs */}
					<div className="row no-print">
					<div className="col-md-12">
						{(this.state.season.formatTeamIndiv === "TEAMS") ? 
							<button className={"btn " + teamsStandingsBtnClass + " btn-margin-right-10"} onClick={this.teamsButtonClicked}>
								Classement des Équipes
							</button>
						: null}

						{!noMatchPlayedBtn ? 
						<React.Fragment>
						<button className={"btn " + playersStandingsBtnClass + " btn-margin-right-10"} onClick={this.playersButtonClicked}>
							Classement des Joueurs
						</button>

						<button className={"btn " + matchsPlayedBtnClass + " btn-margin-right-10"} onClick={this.matchsPlayedButtonClicked}>
							Liste des Matchs joués
						</button>
						</React.Fragment>
						: null}

						<br/><br/>
					</div>
					</div>

				</div>
				<div className="col-md-4 no-print">
					{this.displayCharterImage()}
					{this.displayCustomer()}
				</div>
			</div>

			{(this.state.standingOption === "players") ? 
				<PlayerStanding season={this.state.season}
					printLeagueMsg={this.state.printLeagueMsg} togglePrintLeagueMsg={this.togglePrintLeagueMsg} /> 
					: null}

			{(this.state.standingOption === "teams") ? 
				<TeamStanding season={this.state.season} 
					printLeagueMsg={this.state.printLeagueMsg} togglePrintLeagueMsg={this.togglePrintLeagueMsg} /> 
					: null}

			{(this.state.standingOption === "matchs") ? 
				<MatchsPlayed season={this.state.season} 
					printLeagueMsg={this.state.printLeagueMsg} togglePrintLeagueMsg={this.togglePrintLeagueMsg} /> 
					: null}

			</div>
		);
	}

	teamRostersClick() {
		const path = '/teamRosters/' + this.props.params.seasonTag;
		this.props.navigate(path);		
	}

	liveScoresheetsClick() {
		const path = '/liveScoresheets/' + this.props.params.seasonTag;
		this.props.navigate(path);		
	}

	rateSysFormClick() {
		const path = '/rateSysForm/' + this.props.params.seasonTag;
		this.props.navigate(path);		
	}


	teamsButtonClicked() {
		const { season: { _id: seasonId }, standingOption } = this.state;
		if (standingOption !== "teams") {
			this.setNewCustomerPub('page change', 'Teams', seasonId);
			this.setState({
				standingOption: "teams"
			});
		}
	}

	playersButtonClicked() {
		const { season: { _id: seasonId }, standingOption } = this.state;
		if (standingOption !== "players") {
			this.setNewCustomerPub('page change', 'Players', seasonId);
			this.setState({
				standingOption: "players"
			});
		}
	}
	
	matchsPlayedButtonClicked() {
		const { season: { _id: seasonId }, standingOption } = this.state;
		if (standingOption !== "matchs") {
			this.setNewCustomerPub('page change', 'Matchs', seasonId);
			this.setState({
				standingOption: "matchs"
			});
		}
	}

	dispSeasonMsgButton1() {
		if ((this.state.season.seasonMessageButtonText1 !== "") && (this.state.season.seasonMessageButtonLink1 !== "")) {
			return (
				<button className="btn btn-primary btn-sm btn-fluid btn-margin-right-10"
					onClick={this.seasonMsgButton1Click} value="Appliquer"> {this.state.season.seasonMessageButtonText1} </button>
			);
		}
	}

	dispSeasonMsgButton2() {
		if ((this.state.season.seasonMessageButtonText2 !== "") && (this.state.season.seasonMessageButtonLink2 !== "")) {
			return (
				<button className="btn btn-primary btn-sm btn-fluid"
					onClick={this.seasonMsgButton2Click} value="Appliquer"> {this.state.season.seasonMessageButtonText2} </button>
			);
		}
	}

	seasonMsgButton1Click() {
		window.location.href = this.state.season.seasonMessageButtonLink1;
	}
	seasonMsgButton2Click() {
		window.location.href = this.state.season.seasonMessageButtonLink2;
	}

	displayCharterImage() {
		var charterLink = '';
		var charterImg = '';
		var altText = '';

		if (this.state.season.stateloLeagueParam.includes('QVNEA')) {
			charterLink = "http://qvnea.com";
			charterImg = "/img/qvnea_logo_01.png";
			altText = "qvnea";
		}

		if (charterImg === "") {
			return;
		} else {
			return (
				<div>
					<a href={charterLink} target="_blank">
            <img className="img-fluid" src={charterImg} alt={altText} width="400"/>
					</a>
					<br/><br/>
				</div>
			);
		}
	}

	displayCustomer() {
		if (this.state.custData.show) {
			return (
				<div>
					<a href={this.state.custData.custLink} target="_blank">
            <img className="img-fluid" src={this.state.custData.custImg} 
            	alt={this.state.custData.altText} width="320" onClick={this.pubEventsPubClicked}/>
					</a>
					<br/><br/>
				</div>
			);
		}
	}

	splitTextLinesWithCR(textOnMultipleRows, dispEmptyMsgDefault) {
  	var emptyMsg = "";
  	if (dispEmptyMsgDefault) {
		emptyMsg = "(Aucun message)";
  	}

  	if (textOnMultipleRows && (typeof textOnMultipleRows !== "undefined")) {
			return textOnMultipleRows.split('\n').map(function(item, i) {
				return ( 
					<span className="word-wrap" key={'tomr.' + i}> 
						<Linkify options={linkifyOptions}>{item}</Linkify>
						<br/>
					</span> );
			})
		} else {
			return ( 
				<span>
					{emptyMsg}
					{dispEmptyMsgDefault ? <br/> : null}
				</span> );			
		}
	}

	pubEventsPubShowed(custData, typeA, typeB, seasonId) {
		// Log Events from customer pub
		if (custData.show) {
			var pubEventData = {
				version: 2,
				date: new Date(),
				desc: 'shown',
				typeA: typeA,		// [loading, page change]
				page: typeB,		// [teams, players, matchs]
				seasonId: seasonId,
				custId: custData.custId,
				custPdesc: custData.custPdesc,
			};

			Axios.post('/api/pubEvents/', { 
				pubEventData: pubEventData 
			});
		}
	}

	pubEventsPubClicked() {
		// Log Events from user
		var pubEventData = {
			date: new Date(),
			desc: 'clicked',
			page: 'Player Standings',
			seasonId: this.state.season._id,
			custId: this.state.custData.custId,
			custPdesc: this.state.custData.custPdesc,
		};

		Axios.post('/api/pubEvents/', { 
			pubEventData: pubEventData 
		});
	}

	togglePrintLeagueMsg() {
		this.setState({printLeagueMsg: !this.state.printLeagueMsg});
	}

}

export default withRouter(Standings);
